module.exports = __webpack_public_path__ + "img/invoice-de-female-by.bbe3d6fe.png";